import React from "react";
import cookies from "js-cookie";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import UserService from "../../services/UserService";
import SettingsPanel from "../shared/SettingsPanel";
import DataTable from "react-data-table-component";
import { Button, Card, Col, Row, Modal, Form } from "react-bootstrap";
import service from "../../services/service";
import { downloadExcel, DownloadTableExcel } from "react-export-table-to-excel";
import jsPDF from "jspdf";
import swal from 'sweetalert';
import moment from 'moment';
import adminServices from '../../services/adminServices';
import ReactSelect from 'react-select';

const customStyles = {
  title: {
    style: {
      fontColor: "red",
      fontWeight: "900",
    },
  },
  headCells: {
    style: {
      fontSize: "16px",
      fontWeight: "500",
      paddingLeft: "0 8px",
      marginLeft: "10px",
    },
  },
  cells: {
    style: {
      fontSize: "14px",
    },
  },
};

const customStyles2 = {
  title: {
    style: {
      fontColor: "red",
      fontWeight: "900",
    },
  },
  headCells: {
    style: {
      fontSize: "16px",
      fontWeight: "500",
      paddingLeft: "0 8px",
      marginLeft: "10px",

    },
  },
  cells: {
    style: {
      fontSize: "14px",
      background: "#ccf2ff",
      fontWeight: "bold",
    },
  },
};

const languages = [
  {
    code: "en",
    name: "English",
    country_code: "gb",
  },
];

export default function EnrollementReport() {

  const currentLanguageCode = cookies.get("i18next") || "en";
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode);
  const { t } = useTranslation();

  useEffect(() => {
    document.body.dir = currentLanguage.dir || "ltr";
    document.title = t("app_title");
  }, [currentLanguage, t]);

  useEffect(() => {
    UserService.generateToken();
  }, []);

  const [getSelectedReport, setSelectedReport] = useState();
  const [getCourseStatusList, setCourseStatusList] = useState([]);
  const [courseList, setCourseList] = useState([]);

  let filteredItems = getCourseStatusList.sort((a, b) => new Date(b.commencementDate) - new Date(a.commencementDate));

  useEffect(() => {
    service
      .getCourseandFeesStatus()
      .then((res) => {
        //console.log(res.data);
        setCourseStatusList(res.data);
      })
      .catch((err) => { });
    getAllCourseList();

  }, []);

  const getAllCourseList = () => {
    service.getAllCourses().then((resp) => {
      setCourseList(resp.data);
    }).catch((err) => {

    })
  }

  const tableExportExcel = () => {

    var checkData = [];
    const header = ["Course ID", "Course Name", "Total Enrolled", "Total Approved", "Total Rejected", "Total Confirmed (Fees paid)", "Total (Fees Pending)"]
    if (getCourseStatusList !== undefined) {
      getCourseStatusList.map((data) => {
        const courseId = `${data.courseId}`;
        const courseName = `${data.courseName}`;
        const totalEnrolledLearner = `${data.totalEnrolledLearner}`;
        const totalApprovedLearner = `${data.totalApprovedLearner}`;
        const totalRejectedLearner = `${data.totalRejectedLearner}`;
        const feesPaidLearner = `${data.feesPaidLearner}`;
        const feesPendingLearner = `${data.feesPendingLearner}`;

        const instData = [courseId, courseName, totalEnrolledLearner, totalApprovedLearner, totalRejectedLearner, feesPaidLearner, feesPendingLearner]
        checkData.push(instData);
      })
    }
    downloadExcel({
      fileName: "Course-wise-enrollment-report",
      sheet: "Course-wise-enrollment-report",
      tablePayload: {
        header,
        body: checkData,
      },
    })
  }

  const tableExportPDF = () => {

    const unit = "pt";
    const size = "A4";
    const orientation = "landscape"
    const doc = new jsPDF(orientation, unit, size);
    doc.setFontSize(13);
    const title = "Course Learner List";
    const headers = [["Course ID", "Course Name", "Total Enrolled", "Total Approved", "Total Rejected", "Total Confirmed (Fees paid)", "Total (Fees Pending)"]];
    var checkData = [];
    if (getCourseStatusList !== undefined) {
      getCourseStatusList.map((data) => {
        const courseId = `${data.courseId}`;
        const courseName = `${data.courseName}`;
        const totalEnrolledLearner = `${data.totalEnrolledLearner}`;
        const totalApprovedLearner = `${data.totalApprovedLearner}`;
        const totalRejectedLearner = `${data.totalRejectedLearner}`;
        const feesPaidLearner = `${data.feesPaidLearner}`;
        const feesPendingLearner = `${data.feesPendingLearner}`;

        const instData = [courseId, courseName, totalEnrolledLearner, totalApprovedLearner, totalRejectedLearner, feesPaidLearner, feesPendingLearner]
        checkData.push(instData);
      })
    }
    let content = {
      startY: 50,
      head: headers,
      body: checkData
    };
    doc.text(title, 40, 40);
    doc.autoTable(content);
    doc.save("Course-wise-enrollment-report.pdf")

  }

  const DatewiseTableExportExcel = () => {

  }

  const DatewiseExportPDF = () => {

  }

  const columns = [
    {
      name: "S.No",
      selector: (row, index) => index + 1,
      width: "100px",
      sortable: true,
    },
    // {
    //   name: "Course ID",
    //   selector: (row) => `${row.courseId}`,
    //   sortable: true,
    //   wrap: true,
    // },
    {
      name: "Course Name",
      selector: (row) => `${row.courseName}`,
      sortable: true,
      width: "350px",
      wrap: true,
    },
    {
      name: "Total Enrolled",
      selector: (row) => row.totalEnrolledLearner,
      sortable: true,
      wrap: true,
    },
    {
      name: "Total Approved",
      selector: (row) => row.totalApprovedLearner,
      sortable: true,
      wrap: true,
    },
    {
      name: "Total Rejected",
      selector: (row) => row.totalRejectedLearner,
      sortable: true,
      wrap: true,
    },
    {
      name: "Total Confirmed (Fees paid)",
      selector: (row) => row.feesPaidLearner,
      sortable: true,
      wrap: true,
    },
    {
      name: "Total (Fees Pending)",
      selector: (row) => row.feesPendingLearner,
      sortable: true,
      wrap: true,
    },
  ];

  const columnsForDateWise = [
    {
      name: "Total Learner Count",
      selector: (row) => `${row.totalLearnerCount}`,
      sortable: true,
      wrap: true,
    },
    {
      name: "Enrolled Learner Count(Paid)",
      selector: (row) => row.PaidlearnerCount,
      sortable: true,
      wrap: true,
    },
    {
      name: "Approved Learner Count(unPaid)",
      selector: (row) => row.unPaidApprovedlearnerCount,
      sortable: true,
      wrap: true,
    },
    {
      name: "UnApproved Learner Count",
      selector: (row) => row.unApprovedlearnerCount,
      sortable: true,
      wrap: true,
    },
    {
      name: "Rejected Learner Count",
      selector: (row) => row.rejectedlearnerListCount,
      sortable: true,
      wrap: true,
    },
  ];

  const [courseDetailsShow, setCourseDetailsShow] = useState(false);

  const [getEnrollmentDatabyDate, setEnrollmentDatabyDate] = useState([]);

  const [getCourseandDatewiseEnrollmentList, setCourseandDatewiseEnrollmentList] = useState([]);


  const [enrollmentDateRange, setEnrollmentDateRange] = useState({
    fromDate: '',
    toDate: ''
  })
  const [enrollmentDateRangeError, setEnrollmentDateRangeError] = useState({
    fromDateError: '',
    toDateError: '',
    selectError: '',
  });

  const [submitLoading, setSubmitLoading] = useState({
    isLoading: false
  })

  const [getCourseIdName, setCourseIdName] = useState({
    id: ''
  })

  const [courseEnrollementDateRange, setCoursePayment] = useState({
    fromDate: '',
    toDate: ''
  })

  const [courseEnrollmentDateRangeError, setCoursePaymentRangeError] = useState({
    fromDateError: '',
    toDateError: '',
    selectError: '',
  });

  const [getCoursePaymentDetails, setCoursePaymentDetails] = useState([]);

  const [submitCourseLoading, setSubmitCourseLoading] = useState({
    isLoading: false
  })

  const CoursedateHandler = (e) => {
    setCoursePayment({
      ...courseEnrollementDateRange,
      [e.target.name]: e.target.value
    })
  }


  const enrollmentDateRangeValidate = () => {
    let fromDateErr = ''
    let toDateErr = ''
    let selectErr = ''

    if (!enrollmentDateRange.fromDate) {
      fromDateErr = t('Date_required')
    }
    if (!enrollmentDateRange.toDate) {
      toDateErr = t('Date_required')
    }

    if (enrollmentDateRange.fromDate && enrollmentDateRange.toDate) {
      const from = new Date(enrollmentDateRange.fromDate).getTime();
      const to = new Date(enrollmentDateRange.toDate).getTime();
      if (from > to) {
        fromDateErr = t('should_be_less_than_to_date')
      }
    }
    if (fromDateErr || toDateErr || selectErr) {
      setEnrollmentDateRangeError({
        ...enrollmentDateRangeError,
        fromDateError: fromDateErr,
        toDateError: toDateErr,
        selectError: selectErr,
      })
      return false
    }
    return true
  }

  const dateHandler = (e) => {
    setEnrollmentDateRange({
      ...enrollmentDateRange,
      [e.target.name]: e.target.value
    })
  }

  const onClickSubmitDate = () => {
    // //console.log(UserService.getUserid())
    ////console.log(enrollmentDateRange);
    const condition = enrollmentDateRangeValidate();
    if (condition) {
      setEnrollmentDateRangeError({
        ...enrollmentDateRangeError,
        fromDateError: '',
        toDateError: '',
        selectError: '',
      })
      setSubmitLoading({ isLoading: true });
      service.getDatewiseEnrollmentReport(enrollmentDateRange.fromDate, enrollmentDateRange.toDate)
        .then((resp) => {
          if (resp.status == 200) {
            setEnrollmentDatabyDate(resp.data);
          }
          else {
            swal(t('error_mesg'), t('try_sometimes'), "error");
          }
          setSubmitLoading({ isLoading: false });
        }).catch((err) => {

        })
    }
  }

  const courseEnrollmentDateRangeValidate = () => {
    let fromDateErr = ''
    let toDateErr = ''
    let selectErr = ''

    if (!getCourseIdName.id || getCourseIdName.id === 'Choose......') {
      selectErr = `${t('select_the_name')}`
      setCoursePaymentDetails([]);
    }

    if (!courseEnrollementDateRange.fromDate) {
      fromDateErr = `${t('Date_required')}`
    }
    if (!courseEnrollementDateRange.toDate) {
      toDateErr = `${t('Date_required')}`
    }

    if (courseEnrollementDateRange.fromDate && courseEnrollementDateRange.toDate) {
      const from = new Date(courseEnrollementDateRange.fromDate).getTime();
      const to = new Date(courseEnrollementDateRange.toDate).getTime();
      if (from > to) {
        fromDateErr = `${t('should_be_less_than_to_date')}`
      }
    }
    if (fromDateErr || toDateErr || selectErr) {
      setCoursePaymentRangeError({
        ...courseEnrollmentDateRangeError,
        fromDateError: fromDateErr,
        toDateError: toDateErr,
        selectError: selectErr,
      })
      return false
    }
    return true
  }

  const onClickSubmitCourseDetails = async () => {
    // setUpdateCoursePayments(false)
    // setPaymentDetails([])
    const condition = courseEnrollmentDateRangeValidate();
    if (condition) {
      setCoursePaymentRangeError({
        ...courseEnrollmentDateRangeError,
        fromDateError: '',
        toDateError: '',
        selectError: '',
      })
      setCourseDetailsShow(true);
      setSubmitCourseLoading({ isLoading: true });
      service.getCourseandDatewiseEnrollmentReport(getCourseIdName.id, courseEnrollementDateRange.fromDate, courseEnrollementDateRange.toDate)
        .then((resp) => {
          const newPaymentEntry = [];
          //
          if (resp.data.length === 0) {
            setSubmitCourseLoading({ isLoading: false });
          }
          setCourseandDatewiseEnrollmentList(resp.data);
          // {
          //   resp.data.forEach(async (data1) => {

          //     var t = new Date(data1.transactionDate);
          //     var formatted = moment(t).format('lll');

          //   })

          // }
        })
        .catch((err) => {

        })
    }
  }

  return (<div className="container-scroller">
    <Navbar />
    {/* <StickyMenu /> */}
    <div className="container-fluid page-body-wrapper">
      <Sidebar />
      <div className="main-panel">
        <div className="content-wrapper">
          <div className="page-header">
            <h3 className="page-title">Enrollement Reports</h3>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="!#" onClick={(event) => event.preventDefault()}>
                    Reports
                  </a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Enrollement Reports
                </li>
              </ol>
            </nav>
          </div>
          <div className="card " style={{ padding: "40px" }}>
            <div className=" border bg-white p-4 mt-3">
              <Form.Group>
                <label><h5>Select Enrollement Report</h5></label>
                <Form.Control
                  onChange={e => {
                    setSelectedReport(e.target.value);
                    setSubmitCourseLoading({ isLoading: false });
                    setSubmitLoading({ isLoading: false });
                  }}
                  as='select'
                  placeholder='Select Report'
                >
                  <option selected>{t('choose')}</option>
                  <option value={"course-wise"}>Course Wise Report</option>
                  <option value={"date-wise"}>Date Wise Report</option>
                  <option value={"course-date-wise"}>Course and Date Wise Report</option>
                </Form.Control>
              </Form.Group>
            </div>

            {(getSelectedReport == "course-wise") && (<div className="card-body">
              <Col lg="3">
                <div className="d-flex px-2">
                  <Button
                    onClick={tableExportExcel}
                    style={{
                      marginRight: "5px",
                      background: "#f0ad4e",
                      border: "0px",
                    }}
                  >
                    {" "}
                    {t("export_to_excel")}{" "}
                  </Button>
                  <Button
                    onClick={tableExportPDF}
                    style={{ background: "#f0ad4e", border: "0px" }}
                  >
                    {" "}
                    {t("export_to_pdf")}{" "}
                  </Button>
                </div>
              </Col>
              <br></br>
              <Row>
                <div style={{ overflowX: "auto" }}>
                  <DataTable
                    columns={columns}
                    data={filteredItems}
                    striped
                    pagination
                    highlightOnHover
                    customStyles={customStyles}
                  />
                </div>
              </Row>
            </div>)}

            {(getSelectedReport == "date-wise") && (<div className="card-body">
              <Row>
                <div class="col-8 col-md-4">
                  <label class="control-label" for="name">{t('from_date')} : </label>
                  <input type="date" class="form-control" step="1" id="publishDate" name="fromDate" value={enrollmentDateRange.fromDate} onChange={dateHandler} />
                  {
                    enrollmentDateRangeError.fromDateError
                      ?
                      <div className="alert alert-danger mt-2">{enrollmentDateRangeError.fromDateError}</div>
                      :
                      <></>
                  }
                </div>
                <div class="col-8 col-md-4">
                  <label class="control-label" for="name">{t('to_date')} : </label>
                  <input type="date" class="form-control" title={t('select_course_publish_date')} step="1" id="enrollSdate" name="toDate" value={enrollmentDateRange.toDate} onChange={dateHandler} />
                  {
                    enrollmentDateRangeError.toDateError
                      ?
                      <div className="alert alert-danger mt-2">{enrollmentDateRangeError.toDateError}</div>
                      :
                      <></>
                  }
                </div>
                <div style={{ marginTop: '25px' }}>
                  <Button onClick={onClickSubmitDate} disabled={submitLoading.isLoading ? "true" : ""} style={{ background: "green", border: "0px" }}> {submitLoading.isLoading ? (<> {t('loading')}</>) : (<>{t('submit')}</>)}  </Button>
                </div>
              </Row>
              <br></br>
              <Row>
                <Col lg="9"></Col>
                <Col lg="3">
                  <div className="d-flex px-2">
                    <Button
                      onClick={DatewiseTableExportExcel}
                      style={{
                        marginRight: "5px",
                        background: "#f0ad4e",
                        border: "0px",
                      }}
                    >
                      {" "}
                      {t("export_to_excel")}{" "}
                    </Button>
                    <Button
                      onClick={DatewiseExportPDF}
                      style={{ background: "#f0ad4e", border: "0px" }}
                    >
                      {" "}
                      {t("export_to_pdf")}{" "}
                    </Button>
                  </div>
                </Col>
              </Row>
              <br></br>
              <Row>
                <Col>
                  <div style={{ overflowX: "auto" }} >
                    <DataTable
                      columns={columnsForDateWise}
                      data={getEnrollmentDatabyDate}
                      striped
                      highlightOnHover
                      customStyles={customStyles}
                    />
                  </div>
                </Col>
              </Row>
            </div>)}
            {(getSelectedReport == "course-date-wise") && (<div className="card-body">
              <Row>
                <div class="col-8 col-md-4">
                  {/* <Form.Group>
                    <label>{t('select_the_course')}</label>
                    <Form.Control
                      onChange={e => {
                        setCourseIdName({
                          ...getCourseIdName,
                          id: e.target.value
                        });
                        setSubmitCourseLoading({ isLoading: false });
                      }}
                      as='select' placeholder='Select Course' >
                      <option selected>{t('choose')}</option>
                      {
                        courseList.map((course, index) => {
                          return (
                            <option value={
                              course.courseId
                            }>
                              {course.courseName}
                            </option>
                          )
                        })
                      }
                    </Form.Control>
                  </Form.Group> */}
                  <ReactSelect options={courseList.map(course => ({
                    value: course.courseId,
                    label: course.courseName
                  }))}
                    placeholder={t("choose")}
                    onChange={selectedOption => {
                      setCourseIdName({
                        ...getCourseIdName,
                        id: selectedOption ? selectedOption.value : ""
                      });
                      setSubmitCourseLoading({ isLoading: false });
                    }} />

                </div>
              </Row>
              <br>
              </br>
              <Row >
                <div className="col-8 col-md-4 mb-3 mb-md-0">
                  <label class="control-label" for="name">{t('from_date')} : </label>
                  <input type="date" class="form-control" step="1" id="publishDate" name="fromDate" value={courseEnrollementDateRange.fromDate} onChange={CoursedateHandler} />
                  {
                    courseEnrollmentDateRangeError.fromDateError
                      ?
                      <div className="alert alert-danger mt-2">{courseEnrollmentDateRangeError.fromDateError}</div>
                      :
                      <></>
                  }
                </div>
                <div className="col-8 col-md-4 mb-3 mb-md-0">
                  <label class="control-label" for="name">{t('to_date')}</label>
                  <input type="date" class="form-control" title="Select Course Publish Date" step="1" id="enrollSdate" name="toDate" value={courseEnrollementDateRange.toDate} onChange={CoursedateHandler} />
                  {
                    courseEnrollmentDateRangeError.toDateError
                      ?
                      <div className="alert alert-danger mt-2">{courseEnrollmentDateRangeError.toDateError}</div>
                      :
                      <></>
                  }
                </div>
                <div className="col-8 col-md-4" style={{ marginTop: "25px" }}>
                  <Button onClick={onClickSubmitCourseDetails} disabled={submitCourseLoading.isLoading ? "true" : ""} style={{ background: "green", border: "0px" }}>{submitCourseLoading.isLoading ? (<> {t('loading')}</>) : (<>{t('submit')}</>)}</Button>
                </div>
              </Row>
              <br></br>
              <Row>
                <Col>
                  <div style={{ overflowX: "auto" }} >
                    <DataTable
                      columns={columnsForDateWise}
                      data={getCourseandDatewiseEnrollmentList}
                      striped
                      highlightOnHover
                      customStyles={customStyles}
                    />
                  </div>
                </Col>
              </Row>
            </div>)}
          </div>
        </div>
        <SettingsPanel />
        <Footer />
      </div>
    </div>
  </div>
  );
}